import React from "react";
import { MAPKEY_FORM_VALUE, getStatusTags } from "./service";
import Moment from "react-moment";

export default (col, gatewayList) => {
  return [
    {
      // align: "center",
      dataIndex: "b",
      render: (sentDate) => {
        if (!sentDate) return "-";
        return (
          <Moment tz="Etc/UTC" format="MMM DD YYYY HH:mm">
            {sentDate}
          </Moment>
        );
      },
      title: "Sent Date",
    },
    {
      // align: "center",
      dataIndex: "a",
      title: "MemberID",
    },
    {
      // align: "center",
      title: "Gateway",
      render: (record) => {
        if (!!!col) {
          return "-";
        }
        const gatewayKey = MAPKEY_FORM_VALUE[col]["gateway"];
        const gatewayId = record[gatewayKey];

        const findGateway = gatewayList.filter((i) => {
          return i.id === gatewayId;
        });

        let name = "-";
        if (findGateway.length > 0) {
          name = findGateway[0]["name"];
        }

        return name;
      },
    },
    {
      // align: "center",
      title: "Status",
      render: (record) => {
        if (!!!col) {
          return "-";
        }

        const statusKey = MAPKEY_FORM_VALUE[col]["status"];

        return getStatusTags(record[statusKey] || "");
      },
    },
    {
      // align: "center",
      dataIndex: "c",
      title: "Phone",
    },
    {
      // align: "center",
      title: "Sender",
      render: (record) => {
        if (!!!col) {
          return "-";
        }
        const senderKey = MAPKEY_FORM_VALUE[col]["sender"];

        return record[senderKey];
      },
    },
  ];
};



// WEBPACK FOOTER //
// ./src/containers/SlRawLogs/column.js